import React from 'react';
import './Clients.css';
import Menu from '../Menu/Menu';
import c1 from '../../img/c1.jpg';
import c2 from '../../img/c2.jpg';
import c3 from '../../img/c3.jpg';
import c4 from '../../img/c4.png';
import c5 from '../../img/no-logo-MANUFACTURER.png';
import c6 from '../../img/c6.png';
import c7 from '../../img/no-logo-MANUFACTURER.png';
import c8 from '../../img/c8.jpg';
import c9 from '../../img/c9.png';
import c10 from '../../img/c10.jpg';
import c11 from '../../img/c11.png';



const Clients = () => {
    return (
        <div className='mb-5'>
            
            <div className='about11'>
                <div className='bg'>
                    <Menu></Menu>
                    <h1 className='text-white display-5 fw-bold doris pt-lg-5 pb-5 mx-auto top'>Clients</h1>
                </div>
            </div>
                <h2 className='heading pt-5 px-3'>Clients</h2>
                <hr className='w-50 mx-auto'></hr>
                <h5 className='px-5 mx-lg-3'>
                    <div className='row'>
                        <div className='col-lg-3 col-md-3 col-sm-6 p-5'>
                            <div className='container1'>
                                <img src={c1} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">Local Government Engineering Department (LGED)
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='col-lg-3 col-md-3 col-sm-6 p-5'>
                            <div className='container1'>
                                <img src={c2} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">Military Engineer Services (MES)
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-6 p-5'>
                            <div className='container1'>
                                <img src={c3} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">Public Work Department (PWD)
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='col-lg-3 col-md-3 col-sm-6 p-5'>
                            <div className='container1'>
                                <img src={c4} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">Road And High way Department (RHD)
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-3 col-md-3 col-sm-6 p-5'>
                            <div className='container1'>
                                <img src={c5} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">Interior Homes Ltd.
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='col-lg-3 col-md-3 col-sm-6 p-5'>
                            <div className='container1'>
                                <img src={c6} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">Space Design & Development Ltd.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-6 p-5'>
                            <div className='container1'>
                                <img src={c7} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">Jitu Garments
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='col-lg-3 col-md-3 col-sm-6 p-5'>
                            <div className='container1'>
                                <img src={c8} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">Bashundhara Group
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-3 col-md-3 col-sm-6 p-5'>
                            <div className='container1'>
                                <img src={c10} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">Petro Bangla
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='col-lg-3 col-md-3 col-sm-6 px-5 pb-5 pt-2'>
                            <div className='container1'>
                                <img src={c9} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">Beximco Petroleum LTD
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-6 px-5 pb-5 pt-4'>
                            <div className='container1'>
                                <img src={c11} alt="" width="100%" className='image'/>
                                <div className="middle">
                                    <div className="text1">United Group
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </h5>           
        </div>
    );
};

export default Clients;